import React from 'react';
import PropTypes from 'prop-types';

// components
import {Modal, Uploader} from '@drivesally/sally-ui';

// local components
import Container from './components/Content';

const UploadCMSImagesModal = ({loading, visible, onClose, onUpload}) => (
  <Modal
    title="Upload CMS Images"
    icon="upload"
    visible={visible}
    onClose={onClose}
  >
    {(Content) => (
      <Content padding="none">
        <Container>
          <Uploader loading={loading} onChange={onUpload} accept=".zip" small />
        </Container>
      </Content>
    )}
  </Modal>
);

UploadCMSImagesModal.propTypes = {
  loading: PropTypes.bool,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onUpload: PropTypes.func,
};

export default UploadCMSImagesModal;
